module.exports = __webpack_public_path__ + "img/tope.e49a334e.png";